import _ from 'lodash'

import tippy2 from './tippy2'
import tippy4 from 'tippy.js'
// import 'tippy.js//themes/light.css'
import {ApiError} from './sharefunc'

import PNotify from 'pnotify/lib/es/PNotify'
import 'pnotify/lib/es/PNotifyButtons'
import 'pnotify/lib/es/PNotifyConfirm'
import 'pnotify/lib/es/PNotifyCallbacks'
import 'pnotify/dist/PNotifyBrightTheme.css'
import {ScrollLock, Browser} from 'eyes-lib/src/libs'


/** 
 * 振る舞い格納オブジェクト
 * ブラウザやモジュールバージョンによって挙動変更が激しい場合に
 * 処理系を切り離す目的の空間オブジェクト
 */
const Behavior = {
	/**
	 * tippy.jsの挙動
	 */
	tippy: {
		/** v2利用判定。IE10以下はv2利用 */
		isV2: (Browser.IE && Browser.versionNumber < 11),
		v2: {
			InputError: {
				/**
				 * エラー状態を無効化
				 * @param {parsley.Field} evt
				 */
				disable: function (evt)
				{
					/** 対象要素を取得 */
					const $elem = evt.$element
					$elem.removeClass('input-error')
					$elem.attr('title', '' )

					let tippyIns = _.get(evt, 'element._tippy')
					if( tippyIns ) {
						if( tippyIns.popperInstance ) tippyIns.hide()
						/** ツールチップ無効化 */
						tippyIns.disable()
						tippyIns.destroy()
					}
				},
				/**
				 * エラー視覚効果を有効化
				 * @param {parsley.Field} evt
				 * @param {import('tippy.js').Props} [options]
				 */
				enable: function (evt, options = null)
				{
					const msg = evt.getErrorsMessages() || []
			
					/** @type {import('tippy.js').Instance} */
					let tippyIns = _.get(evt, 'element._tippy')

					/** インスタンスがあればいったん削除 */
					if( tippyIns ) tippyIns.destroy()

					/** 対象要素を取得 */
					const $elem = evt.$element
					$elem.addClass('input-error')
					$elem.attr('title', msg.join('\n') ) //ブラウザのツールチップ設定

					/** tippyインスタンスがなければ生成 */
					if( !tippyIns ) tippy2( evt.element, Object.assign({}, options), false )
			
					/** 改めてtippyインスタンスを代入 */
					tippyIns = _.get(evt, 'element._tippy')
					if( tippyIns ) {
						/** ツールチップ有効化 */
						tippyIns.enable()
					}
				}
			}
		},
		v4: {
			InputError: {
				/**
				 * エラー状態を無効化
				 * @param {parsley.Field} evt
				 */
				disable: function (evt)
				{
					/** 対象要素を取得 */
					const $elem = evt.$element
					$elem.removeClass('input-error')
					$elem.attr('title', '' )

					/** @type {import('tippy.js').Instance} */
					let tippyIns = _.get(evt, 'element._tippy')
					if( tippyIns ) {
						if( tippyIns.popperInstance ) tippyIns.hide()
						/** ツールチップ無効化 */
						tippyIns.setContent('')
						tippyIns.disable()
					}
				},
				/**
				 * エラー視覚効果を有効化
				 * @param {parsley.Field} evt
				 * @param {import('tippy.js').Props} [options]
				 */
				enable: function (evt, options = null)
				{
					const msg = evt.getErrorsMessages() || []
			
					/** 対象要素を取得 */
					const $elem = evt.$element
					$elem.addClass('input-error')
					$elem.attr('title', msg.join('\n') ) //ブラウザのツールチップ設定
			
					/** @type {import('tippy.js').Instance} */
					let tippyIns = _.get(evt, 'element._tippy')
			
					/** tippyインスタンスがなければ生成 */
					if( !tippyIns ){
						const opt = Object.assign({}, options)
						console.info('tippy4',this)
						tippy4( evt.element, opt )
					}
			
					/** 改めてtippyインスタンスを代入 */
					tippyIns = _.get(evt, 'element._tippy')
			
					if( tippyIns ) {
						/** ツールチップ有効化 */
						tippyIns.setContent(msg.join('\n'))
						tippyIns.enable()
					}
				}
			}
		}
	},
	PNotify: {
		EVENTS: {
			CONFIRM: 'pnotify:confirm',
			OPEN: 'pnotify:open',
			CLOSE: 'pnotify:close',
		},
		v4: {
			/** アラートの代替え */
			AlertOptions: {
				title: '',
				text: '',
				hide: false,
				icons:'fontawesome4',
				addClass: 'custom-modal',
				stack: {
					// dir1: 'down', // With a dir1 of 'up', the stacks will start appearing at the bottom.
					// firstpos1: 25, // The notices will appear 25 pixels from the bottom of the context.
					// push: 'bottom', // Each new notice will appear at the bottom of the screen, which is where the 'top' of the stack is. Other notices will be pushed up.
					modal: true, // When a notice appears in this stack, a modal overlay will be created.
					overlayClose: true, // When the user clicks on the overlay, all notices in this stack will be closed.
				},
				modules: {
					Confirm: {
						confirm: true,
						buttons: [
							{
								text: 'OK',
								primary: true,
								promptTrigger: true,
								click: function(notice) {
									notice.close()
									notice.fire(Behavior.PNotify.EVENTS.CONFIRM)
								},
							},
						]
					},
					Buttons: {
						closer: false,
						sticker: false,
					},
					Callbacks: {
						afterOpen: (notice)=>{
							ScrollLock.on()
							notice.fire(Behavior.PNotify.EVENTS.OPEN)
						},
						afterClose: (notice)=>{
							ScrollLock.off()
							notice.fire(Behavior.PNotify.EVENTS.CLOSE)
						},
					}
				}
			}
		}
	},
}


/** API認証エラー */
class AuthError extends ApiError {
	constructor( ...params) {
		super(...params)
		this.name = 'AuthError'
	}
}

/** APIサーバーエラー */
class ServerError extends ApiError {
	constructor( ...params) {
		super(...params)
		this.name = 'ServerError'
	}
}

/** Parsley用入力エラー */
class InputError extends Error {
	/**
	 * ツールチップライブラリ`tippy.js`のデフォルトオプション
	 * @type {Partial<import('tippy.js').Props>}
	 */
	static TippyOptions = {
		arrow: true,
		distance: 10,
		multiple: false,
		placement: 'bottom',
		theme: 'tlife',
	}

	/**
	 * Parsley用入力エラー
	 * @description ツールチップ表示に`tippy.js`を利用
	 * @param {parsley.Field} evt - `Parsley.js`のバリデーションイベント
	 * @param {Partial<import('tippy.js').Props>} options - `tippy.js`のオプション
	 * @memberof InputError
	 */
	constructor(evt, options = null) {
		super(evt.getErrorsMessages().join('\n'))
		this.name = 'InputError'
		this.event = evt
		this.options = Object.assign( {}, InputError.TippyOptions, options )
	}

	/**
	 * エラー状態を無効化
	 * @param {parsley.Field} evt
	 */
	static disable(evt){
		if( Browser.IE && Browser.versionNumber < 11 )
			Behavior.tippy.v2.InputError.disable(evt) //!EXIT
		else
			Behavior.tippy.v4.InputError.disable(evt) //!EXIT
	}

	/**
	 * エラー視覚効果を有効化
	 * @param {parsley.Field} evt
	 * @param {import('tippy.js').Props} [options]
	 */
	static enable(evt, options = null){
		const opt = Object.assign( {}, InputError.TippyOptions, options )
		if( Behavior.tippy.isV2 )
			Behavior.tippy.v2.InputError.enable(evt, opt)
		else
			Behavior.tippy.v4.InputError.enable(evt, opt)
	}

	/**
	 * エラー状態を無効化
	 */
	disable(){
		InputError.disable( this.event )

		return this
	}

	/**
	 * エラー視覚効果を有効化
	 * @param {import('tippy.js').Props} [options]
	 */
	enable( options = null ){
		console.log('ERROR')
		if( Behavior.tippy.isV2 )
			Behavior.tippy.v2.InputError.enable(this.event, options)
		else
			Behavior.tippy.v4.InputError.enable(this.event, options)

		return this //!EXIT
	}
}

export {
	PNotify,
	Behavior,
	ApiError,
	ServerError,
	AuthError,
	InputError,
}
